module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "rtitle flex justify-between align-center bg-white rone"
  }, [_c('div', {
    staticClass: "colorleft"
  }, [_vm._v("企业简介")]), _vm._v(" "), (_vm.edit == 0) ? _c('div', {
    staticClass: "editbtn pointer",
    on: {
      "click": function($event) {
        _vm.edit = 1
      }
    }
  }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.edit == 1) ? _c('div', {
    staticClass: "editbtn pointer",
    on: {
      "click": _vm.tosubedit
    }
  }, [_vm._v("确定")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cball"
  }, [_c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "padding": "40px",
      "min-height": "480px"
    }
  }, [(_vm.userinfo) ? _c('div', {}, [(_vm.edit == 1) ? _c('tinymce', {
    attrs: {
      "height": 300
    },
    model: {
      value: (_vm.userinfo.shop.content),
      callback: function($$v) {
        _vm.$set(_vm.userinfo.shop, "content", $$v)
      },
      expression: "userinfo.shop.content"
    }
  }) : _c('div', {
    staticStyle: {
      "min-height": "340px"
    }
  }, [(_vm.userinfo.shop.content) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "word-break": "break-all",
      "overflow": "hidden"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.userinfo.shop.content)
    }
  }) : _c('div', {
    staticStyle: {
      "width": "100%",
      "word-break": "break-all",
      "overflow": "hidden"
    }
  }, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1)])], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c79b88a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mine/company_brief.vue
// module id = 398
// module chunks = 1